export default __webpack_public_path__ + "static/media/title_ja_pc@2x.7b2fe575.png";